import type { ImageProps } from "./Image.d";

import Image from "./Image";

export default Image;
export type { ImageProps };
